import { NORMAL_SIZE_DRAWER, SMALL_SIZE_DRAWER } from './constants';

export const getDrawerSizeInPX = (drawerSize = 'normal') =>
    drawerSize === 'normal' ? NORMAL_SIZE_DRAWER : SMALL_SIZE_DRAWER;
